/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { AuthoringRegion, Region } from 'src/core/types/regionTypes';

const westUsPredictionRegions: Region[] = [
    'westus',
    'westus2',
    'westus3',
    'eastus',
    'eastus2',
    'westcentralus',
    'southcentralus',
    'northcentralus',
    'centraluseuap',
    'canadacentral',
    'centralus',
    'brazilsouth',
    'eastasia',
    'southeastasia',
    'koreacentral',
    'japaneast',
    'japanwest',
    'centralindia',
    'southafricanorth',
    'uaenorth',
    'jioindiawest'
];
const westEuropePredictionRegions: Region[] = ['westeurope', 'northeurope', 'uksouth', 'francecentral', 'norwayeast'];
const switzerlandNorthPredictionRegions: Region[] = ['switzerlandnorth', 'switzerlandwest'];
const australiaEastPredictionRegions: Region[] = ['australiaeast'];
const usGovVirginiaPredictionRegions: Region[] = ['usgovvirginia', 'usgovarizona'];
const chinaEastPredictionRegions: Region[] = ['chinaeast2', 'chinanorth2'];
const usNatWestPredictionRegions: Region[] = ['usnatwest', 'usnateast'];
const usSecEastPredictionRegions: Region[] = ['usseceast', 'ussecwest'];

export const allPublicRegions: Region[] = [
    ...westUsPredictionRegions,
    ...westEuropePredictionRegions,
    ...australiaEastPredictionRegions,
    ...switzerlandNorthPredictionRegions
];

/**
 * A map of the authoring regions and their allowed
 * endpoint regions. That means users accessing LUIS
 * from these authoring regions are only allowed to create prediction
 * accounts from the respective regions in the map defined here.
 */
export const allowedCsAccountRegions = new Map<AuthoringRegion, Region[]>([
    ['westus', westUsPredictionRegions],
    ['westus2', westUsPredictionRegions],
    ['usnatwest', usNatWestPredictionRegions],
    ['usseceast', usSecEastPredictionRegions],
    ['centraluseuap', westUsPredictionRegions],
    ['chinaeast2', chinaEastPredictionRegions],
    ['westeurope', westEuropePredictionRegions],
    ['australiaeast', australiaEastPredictionRegions],
    ['usgovvirginia', usGovVirginiaPredictionRegions],
    ['switzerlandnorth', switzerlandNorthPredictionRegions]
]);

export const publicAuthoringRegions: AuthoringRegion[] = ['westus', 'westeurope', 'switzerlandnorth', 'australiaeast', 'centraluseuap'];
export const privateAuthoringRegions: AuthoringRegion[] = ['chinaeast2', 'usgovvirginia', 'usnatwest', 'usseceast'];
